import React, { Component } from 'react';
import { Auth } from '../../../../services/api';
import { Button, Alert } from 'antd';
import Spinner from '../../../../components/Spinner';

export default class Verify extends Component {
    constructor(props) {
        super(props);

        this.authApi = new Auth();    

        const query = new URLSearchParams(this.props.location.search);
        this.state = {
            loading: false,
            success: false,
            error: {
                verified: false,
                expired: false
            },
            email: query.get('email') !== null ? query.get('email').replace(' ', '+') : '',
            code: query.get('code') !== null ? query.get('code') : ''
        };
    }

    componentDidMount() {
        this.Verify();
    }

    Verify = () => {
        const { email, code } = this.state;

        this.setState({ loading: true });
        this.authApi.verify({ email, code })
            .then(() => {
                this.setState({ success: true, loading: false });
            })
            .catch(err => {
                const { error } = this.state;
                if (err.response && err.response.status === 400) {
                    error.expired = true;
                } else if (err.response && err.response.status === 409) {
                    error.verified = true;
                }
                this.setState({ loading: false, error });
            });
    };

    goToLogin = () => {
        this.props.history.push(`/auth/login?email=${this.state.email}`);
    }

    render() {
        const { success, error, loading  } = this.state;

        return (
            <div>
                <Spinner loading={loading} />
                {success && (
                    <div>
                        <Alert
                            type="success"
                            showIcon
                            message="Ditt konto är nu verifierat och redo att användas. Klicka nedan för att logga in."
                            style={{ marginBottom: '20px' }}
                        />

                        <Button type="primary" block icon="lock" onClick={this.goToLogin}>
                            Logga in
                        </Button>
                    </div>
                )}
                {error.expired && (
                    <div>
                        <Alert
                            type="error"
                            showIcon
                            message="Din aktiveringslänk är inte giltig längre, men vi har skickat en ny till din e-post."
                            style={{ marginBottom: '20px' }}
                        />
                    </div>
                )}
                {error.verified && (
                    <div>
                        <Alert
                            type="info"
                            showIcon
                            message="Ditt konto är redan verifierat. Klicka nedan för att logga in."
                            style={{ marginBottom: '20px' }}
                        />

                        <Button type="primary" block icon="lock" onClick={this.goToLogin}>
                            Logga in
                        </Button>
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/auth/components/register/Verify.js